module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ly-9c0afe9e70e2e37b432260aae94f67d5.svg";